import React, { useState, useEffect } from 'react';
import { 
  Menu, 
  Zap, 
  Sparkles, 
  Bell, 
  RefreshCw, 
  Settings, 
  Building2 
} from 'lucide-react';
import './SharedHeader.css';

const SharedHeader = ({ onMenuClick }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <header className="shared-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">
          <div className="flex items-center space-x-3">
            {/* Menu Button */}
            <button 
              className="menu-btn-integrated"
              onClick={onMenuClick}
            >
              <Menu className="w-5 h-5" />
            </button>
            
            <div className="flex items-center space-x-3 group">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
                <Zap className="w-6 h-6 text-white group-hover:animate-pulse" />
              </div>
              <div>
                <h1 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent group-hover:from-purple-600 group-hover:to-pink-600 transition-all duration-300">
                  AI Earnings Assistant
                </h1>
                <div className="flex items-center space-x-2">
                  <p className="text-xs text-gray-500">Powered by AI Analytics</p>
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                </div>
              </div>
            </div>
            <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded animate-pulse">
              <Sparkles className="w-3 h-3 mr-1 inline" />
              BETA
            </span>
          </div>
          
          <div className="flex items-center space-x-3">
            {/* Live Time Display */}
            <div className="hidden md:flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-gray-700">{formatTime(currentTime)}</span>
            </div>
            
            {/* Interactive Action Buttons - Bigger with proper styling */}
            <button className="action-btn group">
              <Bell className="w-6 h-6 group-hover:animate-bounce" />
            </button>
            <button className="action-btn group">
              <RefreshCw className="w-6 h-6 group-hover:animate-spin" />
            </button>
            <button className="action-btn group">
              <Settings className="w-6 h-6 group-hover:rotate-90 transition-transform duration-300" />
            </button>
            
            {/* User Profile */}
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer group">
              <Building2 className="w-5 h-5 text-white group-hover:animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SharedHeader;
